import axios, {AxiosError, AxiosInstance, AxiosRequestConfig} from 'axios';
import {message} from 'antd';
import {getCookie, removeCookie} from 'typescript-cookie';
import {store} from '../store/store';
import {logoutSuccess} from '../store/modules/auth/actions';
import {showSubscriptionModal} from '../components/molecules/Modals/subscription/component';
import {resetAnalyticsUser} from '../analytics/posthog';

const url =
    process.env.REACT_APP_ENV === 'test'
        ? process.env.REACT_APP_LOCAL_URL
        : process.env.REACT_APP_ENV === 'development'
            ? process.env.REACT_APP_DEV_URL
            : process.env.REACT_APP_PROD_URL;

const api: AxiosInstance = axios.create({
    baseURL: url,
    withCredentials: false
});

type ReqConfig = AxiosRequestConfig & { _hadAuth?: boolean };
type ResConfig = AxiosRequestConfig & { _retry?: boolean; _hadAuth?: boolean };

api.interceptors.request.use(
    (config) => {
        const token = getCookie('token');
        (config as ReqConfig)._hadAuth = !!token;
        if (token && config && config.headers) config.headers.Authorization = `Bearer ${token}`;
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

api.interceptors.response.use(
    (res) => res,
    (error: AxiosError) => {
        const response = error.response;
        if (!response) return Promise.reject(error);

        const {status, data, config} = response;
        const originalRequest = config as ResConfig;
        const code = (data as any)?.code;

        if (status === 403 && code === 'NO_ACTIVE_SUBSCRIPTION') {
            showSubscriptionModal();
        } else if (status === 401 && code === 'UNAUTHORIZED' && !originalRequest._retry) {
            originalRequest._retry = true;

            if (getCookie('postRoleReload') === '1') {
                removeCookie('postRoleReload', {path: '/'});
                return Promise.reject(error);
            }

            removeCookie('token', {path: '/'});
            removeCookie('roleType', {path: '/'});
            resetAnalyticsUser();

            store.dispatch(logoutSuccess());
            if (originalRequest._hadAuth) message.warning('Session expired—please log in again.');

            if (window.location.pathname !== '/') window.location.replace('/');
        }

        return Promise.reject(error);
    }
);

export default api;
